import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useRouterState } from "@tanstack/react-router";
import { useContext, useEffect } from "react";

import { NAVBAR } from "../../../config";
import useCollapseDrawer from "../../../hooks/useCollapseDrawer";
import useResponsive from "../../../hooks/useResponsive";
import AccountPopover from "../AccountPopover/AccountPopover";
import Context, { ContextType } from "../context";
import NavbarAppSection from "./nav-app-section/NavbarAppSection";
import NavbarHeader from "./nav-header/NavbarHeader";
import NavbarContent from "./NavbarContent";
import NavbarDrawer from "./NavbarDrawer";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
	[theme.breakpoints.up("lg")]: {
		flexShrink: 0,
		transition: theme.transitions.create("width", {
			duration: theme.transitions.duration.shorter
		})
	}
}));

// ----------------------------------------------------------------------

export default function NavbarVertical() {
	const { location } = useRouterState();

	const isDesktop = useResponsive("up", "lg");

	const { actions, isOpenSidebar }: ContextType = useContext<ContextType>(Context);
	const { onCloseSidebar } = actions;

	const { isCollapse, collapseClick, collapseHover, onToggleCollapse } = useCollapseDrawer();

	useEffect(() => {
		if (isOpenSidebar) {
			onCloseSidebar();
		}
	}, [location.pathname]);

	const renderContent = () => (
		<>
			<NavbarHeader collapseClick={collapseClick} onToggleCollapse={onToggleCollapse} />
			<NavbarAppSection />
			<NavbarContent />
			<AccountPopover />
		</>
	);

	return (
		<RootStyle
			sx={{
				width: {
					lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH
				},
				...(collapseClick && {
					position: "absolute"
				})
			}}
		>
			{!isDesktop && (
				<Drawer
					PaperProps={{
						sx: { width: NAVBAR.DASHBOARD_WIDTH }
					}}
					onClose={onCloseSidebar}
					open={isOpenSidebar}
				>
					{renderContent()}
				</Drawer>
			)}

			{isDesktop && <NavbarDrawer collapseHover={collapseHover}>{renderContent()}</NavbarDrawer>}
		</RootStyle>
	);
}
